const { getElement } = window.BAO.Utils

let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  constructor () {
    super()

    this._lastActiveDropdownId = null
  }

  connectedCallback () {
    super.connectedCallback()

    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=dropdown`,
      )
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleToggleButtonClick.bind(this))

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.handleHover = this.handleHover.bind(this)

    this.addEventListener('pointermove', this.onPointerMove)
    this.addEventListener('mouseleave', this.onMouseLeave)

    this.addEventListener('focusin', this.handleFocusIn.bind(this))

    this.addEventListener('keyup', this.handleEscapePress.bind(this))

    this.els.link?.elements.forEach((linkEl) => {
      this.listeners.add(linkEl, 'mouseenter', this.handleHover)
      this.listeners.add(linkEl, 'focus', this.handleHover)
    })
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    const menuToggleEl = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )

    if (!menuToggleEl) {
      return
    }

    const parentItemEl = menuToggleEl.closest(
      '[data-header-dropdown-el="item"]',
    )
    if (!parentItemEl) return
    const menuDropdownEl = getElement(
      '[data-header-dropdown-el="menu-dropdown"]',
      {
        context: parentItemEl,
      },
    )

    if (!menuDropdownEl) return

    const isExpanded = menuToggleEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.setAttribute('aria-expanded', 'false')
      menuDropdownEl.setAttribute('aria-hidden', 'true')
    } else {
      menuToggleEl.setAttribute('aria-expanded', 'true')
      menuDropdownEl.setAttribute('aria-hidden', 'false')
      this.resetDropdown(menuDropdownEl)
    }
  }

  handleHover (event) {
    const hoverLink = event.target
    const handleLink = hoverLink.dataset.handle
    const mediaHandleLink = hoverLink.dataset.mediaHandle

    if (!handleLink || !mediaHandleLink) return

    const dropdownEl = hoverLink.closest(
      '[data-header-dropdown-el="menu-dropdown"]',
    )
    if (!dropdownEl) return

    const mediaEls = dropdownEl.querySelectorAll(
      '[data-header-dropdown-el="media"]',
    )
    const subnavEls = dropdownEl.querySelectorAll(
      '[data-header-dropdown-el="subnav"]',
    )

    subnavEls.forEach((subnavEl) => {
      subnavEl.setAttribute(
        'aria-hidden',
        subnavEl.dataset.target === handleLink ? 'false' : 'true',
      )
    })

    const fullHandle = mediaHandleLink // e.g. "shop|shoes"
    const [parentHandle] = mediaHandleLink.split('|') // e.g. "shop"

    mediaEls.forEach((mediaEl) => {
      mediaEl.setAttribute('aria-hidden', 'true')
    })

    let matched = false
    mediaEls.forEach((mediaEl) => {
      if (mediaEl.dataset.target === fullHandle) {
        mediaEl.setAttribute('aria-hidden', 'false')
        matched = true
      }
    })

    if (!matched) {
      mediaEls.forEach((mediaEl) => {
        if (mediaEl.dataset.target === parentHandle) {
          mediaEl.setAttribute('aria-hidden', 'false')
          matched = true
        }
      })
    }

    if (!matched) {
      this.showDefaultMedia(dropdownEl)
    }
  }

  resetDropdown (dropdownEl) {
    const mediaEls = dropdownEl.querySelectorAll(
      '[data-header-dropdown-el="media"]',
    )
    mediaEls.forEach((mediaEl) => mediaEl.setAttribute('aria-hidden', 'true'))
    mediaEls.forEach((mediaEl) => {
      if (mediaEl.hasAttribute('data-default')) {
        mediaEl.setAttribute('aria-hidden', 'false')
      }
    })
    const subnavEls = dropdownEl.querySelectorAll(
      '[data-header-dropdown-el="subnav"]',
    )
    subnavEls.forEach((subnavEl) =>
      subnavEl.setAttribute('aria-hidden', 'true'),
    )
  }

  showDefaultMedia (dropdownEl) {
    const mediaEls = dropdownEl.querySelectorAll(
      '[data-header-dropdown-el="media"]',
    )
    mediaEls.forEach((mediaEl) => mediaEl.setAttribute('aria-hidden', 'true'))
    mediaEls.forEach((mediaEl) => {
      if (mediaEl.hasAttribute('data-default')) {
        mediaEl.setAttribute('aria-hidden', 'false')
      }
    })
  }

  onMouseLeave (event) {
    const dropdownEl = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown"]',
    )
    if (dropdownEl) {
      this.resetDropdown(dropdownEl)
    }
    this.closeDropdowns()

    this._lastActiveDropdownId = null
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-hidden="false"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    const menuDropdownToggleEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )
    const menuDropdownEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown"]',
    )

    if (menuDropdownToggleEls) {
      menuDropdownToggleEls.forEach((menuToggleEl) => {
        menuToggleEl.setAttribute('aria-expanded', 'false')
      })
    }

    if (menuDropdownEls) {
      menuDropdownEls.forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute('aria-hidden', 'true')
      })
    }
  }

  onPointerMove (event) {
    const activeTrigger = event.target.closest(
      '[data-header-dropdown-el="trigger"]',
    )

    if (!activeTrigger) {
      this.closeDropdowns()

      this._lastActiveDropdownId = null
      return
    }

    const matchedDropdown = this.querySelector(
      `[data-header-dropdown-el="menu-dropdown"]#${activeTrigger.dataset.id}`,
    )

    if (matchedDropdown) {
      const matchedId = matchedDropdown.id || null
      if (matchedId !== this._lastActiveDropdownId) {
        this.resetDropdown(matchedDropdown)
        this._lastActiveDropdownId = matchedId
      }

      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown"]',
      ).forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute(
          'aria-hidden',
          menuDropdownEl !== matchedDropdown,
        )
      })

      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown-toggle"]',
      ).forEach((menuToggleEl) => {
        menuToggleEl.setAttribute(
          'aria-expanded',
          menuToggleEl.dataset.id === matchedDropdown.id,
        )
      })
    } else {
      this.closeDropdowns()
      this._lastActiveDropdownId = null
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
